import { apiDataManagerBaseURL } from '../../authentication/Global';
import { authenticationCentral } from '../../authentication/Authentication';
import { API, HTTPMethod, ContentType } from '../APICentral';

const regionsApiRoutes = {
    list: apiDataManagerBaseURL + "regions/",
    listTA: apiDataManagerBaseURL + "regions/ta/",
    listByLine: apiDataManagerBaseURL + "regions/",
};

export class RegionAPI {
    static list() {
        const url = regionsApiRoutes.list;

        return API.authenticatedRequest({
            url: url,
            method: HTTPMethod.GET,
            contentType: ContentType.JSON,
            token: authenticationCentral.accessToken
        });
    }

    static listTA(provider) {
        const url = `${regionsApiRoutes.listTA}${provider}`;

        return API.authenticatedRequest({
            url: url,
            method: HTTPMethod.GET,
            contentType: ContentType.JSON,
            token: authenticationCentral.accessToken
        });
    }

    static listByLine(networkEdition, line, provider) {
        const url = new URL(`${networkEdition}/${line}`, regionsApiRoutes.listByLine);

        return API.authenticatedRequest({
            url: provider === '' ? url : `${url}?providerId=${provider}`,
            method: HTTPMethod.GET,
            contentType: ContentType.JSON,
            token: authenticationCentral.accessToken
        });
    }
}



// WEBPACK FOOTER //
// ./src/api/datamanager/RegionAPI.js